import { effectiveRangesStatus } from "../utils/effectiveRanges";

const isSeasonValidForDateRange = (season, asOfRange) => {
	if(!asOfRange) {
		return false;
	}

	const seasonBegin = new Date(season.BeginInclusive);
	const seasonEnd = new Date(season.EndExclusive);
	const rangeStartValue = asOfRange.fromInclusive ?? asOfRange.start;
	const rangeEndValue = asOfRange.toExclusive ?? asOfRange.end;

	if(!rangeStartValue) {
		return false;
	}

	const rangeStart = new Date(rangeStartValue);
	const rangeEnd = rangeEndValue ? new Date(rangeEndValue) : null;

	if(Number.isNaN(rangeStart.getTime()) || (rangeEnd && Number.isNaN(rangeEnd.getTime()))) {
		return false;
	}

	if(!rangeEnd) {
		return seasonEnd > rangeStart;
	}

	const isPointInTime = rangeStart.getTime() === rangeEnd.getTime();

	if(isPointInTime) {
		return rangeStart >= seasonBegin && rangeStart < seasonEnd;
	}

	return rangeStart < seasonEnd && rangeEnd > seasonBegin;
};

export class FeatureCallbacks {
	nestedEntityDateFilter(entity, effectiveAsOf, seasons) {
		if(!entity) {
			return;
		}

		if(entity.Entities) {
			for(const child of entity.Entities) {
				this.nestedEntityDateFilter(child.Entity, effectiveAsOf, seasons);
			}

			return;
		}

		if(!entity.Effective?.length) {
			entity.valid = true;
			entity.inGrace = false;

			return;
		}

		if(!effectiveAsOf) {
			entity.valid = undefined;
			entity.inGrace = undefined;

			return;
		}

		const scopeOf = (item) => item.Scope ?? "NONE";
		const validScopes = (seasons ?? [])
			.filter(season => isSeasonValidForDateRange(season, effectiveAsOf))
			.reduce((acc, season) => {
				const scope = scopeOf(season);
				acc[scope] = true;

				return acc;
			}, {});

		const validRanges = entity.Effective
			.filter(e => validScopes[scopeOf(e)]);
		
		const status = effectiveRangesStatus(validRanges, effectiveAsOf);
		entity.valid = status.isValid;
		entity.inGrace = status.isInGrace;
	}
}

export default angular
	.module("vesl.services.feature-callbacks", [])
	.service("featureCallbacks", FeatureCallbacks).name;
